module.exports = "/_next/static/images/Trend02Visual@2x-4024fd1ac6bdfa0ffcbf1171c20c30df.png";